import { useLanguage } from "@/contexts/LanguageContext";
import videoPoster from "@/assets/proof-plant.jpg";

const PromoVideo = () => {
  const { language } = useLanguage();
  const title = language === "ar" ? "فيديو تعريفي" : "Company Promo";
  const subtitle =
    language === "ar"
      ? "تعرّف على الواحة العربية للحلول الصناعية"
      : "Discover Arabian Al Waha — Industrial & Oilfield Solutions";

  return (
    <section id="promo-video" className="py-16 lg:py-24 bg-primary-darker">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl lg:text-4xl font-bold text-accent mb-3">
            {title}
          </h2>
          <p className="text-primary-foreground/80">{subtitle}</p>
        </div>
        <div className="max-w-4xl mx-auto rounded-xl overflow-hidden shadow-2xl border border-accent/20 bg-black">
          <video
            className="w-full h-auto"
            src="/arabian-al-waha-promo.mp4"
            controls
            playsInline
            preload="metadata"
            poster={videoPoster}
          >
            {language === "ar"
              ? "متصفحك لا يدعم تشغيل الفيديو."
              : "Your browser does not support the video tag."}
          </video>
        </div>
      </div>
    </section>
  );
};

export default PromoVideo;